import type {
  FetchEventDefaultAction,
  FetchEventForIdAction,
  FetchEventForIdFulfilledAction,
  FetchEventForIdRejectedAction,
  FetchEventFulfilledAction,
  FetchEventRejectedAction,
} from "entities/events/actionTypes";
import { EventType } from "entities/events/actionTypes";

export const fetchEventsForTopic = (payload: FetchEventDefaultAction["payload"]): FetchEventDefaultAction => ({
  type: EventType.FETCH_FOR_TOPIC,
  payload,
});

export const fetchEventsForTopicSuccess = (
  payload: FetchEventFulfilledAction["payload"],
  meta: FetchEventFulfilledAction["meta"],
): FetchEventFulfilledAction => ({
  type: EventType.FETCH_FOR_TOPIC_SUCCESS,
  payload,
  meta,
});

export const fetchEventsForTopicFailure = (meta: FetchEventRejectedAction["meta"]): FetchEventRejectedAction => ({
  type: EventType.FETCH_FOR_TOPIC_FAILURE,
  meta,
});

export const fetchEventById = (meta: FetchEventForIdAction["meta"]): FetchEventForIdAction => ({
  type: EventType.FETCH_FOR_ID,
  meta,
});

export const fetchEventByIdSuccessful = (
  payload: FetchEventForIdFulfilledAction["payload"],
  meta: FetchEventForIdFulfilledAction["meta"],
): FetchEventForIdFulfilledAction => ({
  type: EventType.FETCH_FOR_ID_SUCCESS,
  payload,
  meta,
});

export const fetchEventByIdFailure = (meta: FetchEventForIdRejectedAction["meta"]): FetchEventForIdRejectedAction => ({
  type: EventType.FETCH_FOR_ID_FAILURE,
  meta,
});
